<app-header></app-header>

<bit-container>
  <tools-import
    (formDisabled)="this.disabled = $event"
    (formLoading)="this.loading = $event"
    (onSuccessfulImport)="this.onSuccessfulImport($event)"
  ></tools-import>
  <button
    [disabled]="disabled"
    [loading]="loading"
    form="import_form_importForm"
    bitButton
    type="submit"
    bitFormButton
    buttonType="primary"
  >
    {{ "importVerb" | i18n }}
  </button>
</bit-container>
